import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { EnviarPedidoRequest } from '../../requests/compras/enviar-pedido.request';
import { EnviarPedidoResponse } from '../../responses/compras/compra-pedido.response';

@Injectable({
  providedIn: 'root',
})
export class CompraPedidoService extends CommonService {
  private readonly apiUrl: string = environment.urlApiCompras + 'CompraPedido';

  constructor(private httpClient: HttpClient) {
    super();
  }

  public enviarPedidoFornecedor(idCompra: number, destinatario: string, nomeFornecedor?: string, documento?: string,
    idsUsuarioPerfil?: number[]): Observable<EnviarPedidoResponse> {
    const request: EnviarPedidoRequest = { destinatario, nomeFornecedor, documento, idsUsuarioPerfil };
    return this.httpClient
      .post<EnviarPedidoResponse>(`${this.apiUrl}/${idCompra}/enviar`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
